module.exports = __webpack_public_path__ + "static/img/labour-6.5562895.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-6.png
// module id = i0cE
// module chunks = 1